<template>
    <div class="chat">
        <!-- 缩小化 -->
        <div class="small_chat" @click="websocketInit();" v-show="minimizes && showIco">
            <i class="font iconfont chat_handle">&#xebaf;</i>
        </div>
        <!-- <div class="small_chat" @click="chatShow = true">
            <i class="font iconfont chat_handle">&#xebaf;</i>
        </div> -->


            <!-- 聊天界面 -->
            <div class="chat_interface" v-show="!minimizes">
                <!-- 左侧显示聊天好友 -->
                <div class="chat_interface_left">
                    <el-scrollbar v-if="kefuData" ref="myScrollbar" style="height:460px;">
                    <dl class="active" v-for="(v,k) in kefuData" :key="k">
                        <dt><img :src="v.imgfile||'/pc/default_avatar.png'" alt=""></dt>
                        <dd>{{v.nickName||'-'}}</dd>
                    </dl>
                    </el-scrollbar>

                    <el-scrollbar v-else ref="myScrollbar" style="height:460px;">
                    <dl :class="chat_friend.id == v.id?'active':'active2'" v-for="(v,k) in gridData" :key="k">
                        <dt @click="onChatHandle(v)"><img :src="v.imgfile||'/pc/default_avatar.png'" alt=""></dt>
                        <dd @click="onChatHandle(v)">{{v.nickName||'-'}}</dd>
                    </dl>
                    </el-scrollbar>
                </div>
                <div class="chat_interface_right">
                    <div class="chat_interface_right_top">{{kefu_name||'加载中...'}}{{kefu_phone}}<i class="icon iconfont chat_handle" @click="closeWin()">&#xeb9b;</i></div>

                    <!-- 聊天内容 -->
                    <div class="chat_interface_right_content">

                <div v-if="onChatMsg != undefined">
                    <el-scrollbar ref="myScrollbar">
                        <div v-show="viewsMore" @click="viewsChatRecord()" class="clearfix center">查看更多...</div>
                        <div :class="user_id==v.userId?'chat_interface_msg_item me':'chat_interface_msg_item'" v-for="(v,k) in onChatMsg" :key="k">
                            <div class="chat_interface_msg_avatar">
                                <el-image @click="handleViews(v.message)" :src="filePath + v.userImage" >
                                <div slot="error" class="image-slot" style="background: none !important;">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                                </el-image>
                            </div>
                            <div class="chat_interface_msg_time">
                                <span>{{v.userName||'-'}}</span>

                             {{v.sendTime | formatDate}}</div>
                            <div class="chat_interface_msg"  @contextmenu.prevent="handleRightMenu(v)">
                                <div class="chat_image" v-if="v.type=='104'" ><el-image :key="v.message" :src="v.message" ></el-image></div>
                                <div v-else-if="v.type=='103'" v-html="v.message.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)" @contextmenu="deleteOnChatInfo(v)"></div>
                                <div v-else-if="v.type=='106'" @click="handleViewFile(v.message)">查看附件</div>
                                <div v-else>无法识别！</div>
                                <div style="text-align:right" v-show="menuVisible">
                                    <el-tag v-if="user_id==v.userId" @click="handleViews(v.message)" size="small" effect="dark">查看</el-tag>&nbsp;&nbsp;
                                    <el-tag v-if="user_id==v.userId" @click="handleRecant(v)" size="small" effect="dark">撤回</el-tag>&nbsp;&nbsp;
                                    <el-tag @click="handleDelete(v)" size="small" type="danger" effect="dark">删除</el-tag>
                                    </div>
                            </div>
                        </div>
                    <!-- <div v-infinite-scroll="loadMore" v-if="loading" class="clearfix center">加载中...</div>
                    <div v-if="loadend" class="clearfix center"></div> -->
                    </el-scrollbar>
                </div>


                    </div>

                    <!-- 聊天输入框 -->
                    <div class="chat_interface_right_send">
                        <div class="chat_interface_right_send_tool">
                            <div class="tool_item chat_handle">
                            </div>
                            
            <div class="tool_item other_tool_item chat_handle"  @click="viewsChatRecord()"><i class="fa fa-clock-o"></i></div>
           <div class="tool_item other_tool_item chat_handle"  @click="viewsChatEmotion()"><i class="fa fa-smile-o"></i></div>
           <div class="tool_item other_tool_item chat_handle"  @click="viewsChatUpload()">

              <el-upload
                class="upload-demo"
                :action="$api.uploadImage"
                :headers="upload_headers" 
                :on-success="handleAvatarSuccess"
                :show-file-list="false" 
                >
                <i class="fa fa-picture-o"></i>
              </el-upload>
           </div>
           <div class="tool_item other_tool_item chat_handle"  @click="viewsChatUpload()">

              <el-upload
                class="upload-demo"
                :action="$api.uploadFile"
                :headers="upload_headers" 
                :on-success="handleAvatarSuccessFile"
                :show-file-list="false" 
                >
                <i class="fa fa-upload"></i>
              </el-upload>
           </div>
                        </div>
                        <div class="chat_interface_right_send_text">
                            <textarea v-model="sendMsg['message']"></textarea>
                        </div>
                        <div class="chat_interface_right_send_text_btn">
                            <el-button type="primary" size="small" @click="send('text')">发送</el-button>
                            <el-button size="small" @click="closeWin()">关闭</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <el-dialog
            title="选择表情"
            :visible.sync="chatEmotion"
            :close-on-click-modal="true"
            custom-class="custom_class"
            :modal="false">
            <span><emotion v-show="chatEmotion" @emotion="handleEmotion" :height="280" ></emotion></span>
            </el-dialog>
    </div>
</template>

<script>
import Emotion from '@/components/Emotion/index'
import {formatDate} from '@/utils/date';
export default {
    components: {
        Emotion,
    },
    props: {
        minimize:{ // 最小化
            type:Boolean,
            default:true,
        },
        miniItem:{
            type:Boolean,
            default:false,
        },
        sellerId:{
            type:Number,
            default:0,
        }
        
    },
    data() {
      return {
          minimizes:true,
          miniItems:this.miniItem,
          webSocketLink:null,
          music:"/music/chat.wav", // 播放音频地址
          upload_headers:{},
          pageNum:1, // 聊天页码
          pageSize:500,
          showIco:false,

          loading:true,
          loadend:false,
          Num:null,

          socketObj:null,
          chatShow:false,
          isOnline:false, // 是否链接上socket
          isBind:false, // 是否已经绑定
          connect_info:{ // 用户信息，包括聊天好友信息
              user_id:0,
              to_user_id:0,
          }, 
          onChat:[],
          onChatMsg:[], //聊天记录
          chatId:null,  //当前记录ID
          chatUserId:null, //当前记录用户ID

          onChatIndex:0,
          sendMsg:{
              type:'text', // 类型
              message:'', // 内容
          },
          user_info:{}, // 链接成功后获取到的用户信息
          gridData:[],
          user_id:null, //当前用户ID
          user_loginId:null, //当前用户账号
          chat_friend:[], // 客服列表
          kefu_name:null, // 客服姓名
          kefu_phone:null, // 客服电话
          kefuData:[],
          timeObj:null,
          filePath:null,
          menuVisible:false, //右键菜单
          chatRecord:false,  //连接成功后显示聊天记录按钮

          chatEmotion:false,
          upload_headers:{},
      };
    },
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    watch: {},
    computed: {},
    methods: {

    handleEmotion (i) {
      this.sendMsg['message'] = i;
      this.chatEmotion = false;
    },
    // 将匹配结果替换表情图片
    emotion (res) {
      let word = res.replace(/\#|\;/gi,'')
      const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
      let index = list.indexOf(word)
      return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`   
    },

        websocketInit:function(){
            this.minimizes = false;
            //定时请求聊天记录
            this.timeObj = setInterval(()=>{
                this.get_chat_msg();
            },10000);
        },
        send: function (type) {
            let receive
            if(this.kefuData){
                receive = 100000000 +  this.kefuData[0].id ;
            }else{
                receive = 100000000 +  this.chat_friend.id ;
            }
            this.$post(this.$api.sendChat,{user:this.user_id,receive:receive,type:'103',message:this.sendMsg.message,platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
            });
            this.get_chat_msg();
            this.scrollDown();
            this.sendMsg.message = '';
            
            
        },


        insert(emoji) {
            if(this.$isEmpty(this.sendMsg.message)){
                this.sendMsg.message = '';
            }
            this.sendMsg.message += emoji;
            this.$forceUpdate();
        },
        // 滚动条到底部
        scrollDown() {
            this.$nextTick(() => {
                this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
            }) 
        },
        // 清空未读信息
        clearNoRead:function(user_id,to_user_id){
            this.$post(this.$api.chatReadMsg,{user_id:user_id,to_user_id:to_user_id}).then(()=>{});
        },
        // 图片上传成功
        chatUpload:function(res){
            let info = {
                type:'image',
                content:{
                    to_user_id:0,
                    user_id:0,
                    content:'',
                }
            };
            info.content.to_user_id = this.onChat[this.onChatIndex].id;
            info.content.user_id = this.user_info.id;
            info.content.content = res.data;
            // 发送信息
            this.$post(this.$api.chatChatEvent,{data:info}).then(res=>{
                if(res.code == 200){
                    this.scrollDown();
                }else{
                    this.$message.error(res.message);
                }
            });
            this.$forceUpdate();
        },
        
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code==200){
                    this.showIco = true;
                    this.user_id = res.data.id;
                    this.user_loginId = res.data.loginId;
                    this.get_bdService_info();
                    this.get_chat_friend();
                }else{
                    this.showIco = false;
                }
            });
        },


        // 获取客服列表
        get_chat_friend:function(){
            this.$get(this.$api.CustomerService,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data.kfNumber == 0){
                        // return this.$message.error('当前无客服在线,请电话联系!');
                    }else{
                        this.gridData = res.data;
                        this.$forceUpdate();
                    }
                }else{
                    // this.$message.error(res.message);
                }
            });
        },

        // 根据当前用户ID获取绑定客服信息
        get_bdService_info:function(){ 
            this.$get(this.$api.bdService,{loginId:this.user_id,platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data){
                        this.kefuData = res.data;
                        this.kefu_name = res.data[0].nickName;
                        this.kefu_phone = res.data[0].phone;
                        // this.chat_friend.id = res.data[0].id;
                        this.get_chat_msg();
                    }
                }else{
                    // this.$message.error(res.message);
                }
            });

        },


        //打开表情框
        viewsChatEmotion:function(){
        this.chatEmotion = true;
        },
        // 打开聊天框
        onChatHandle:function(info){
            this.chat_friend.loginId = info.loginId;
            this.chat_friend.id = 100000000 + info.id;
            this.chat_friend = info;
        // if(this.kefuData){
        //     this.kefu_name = this.kefuData.nickName;
        //     this.kefu_phone = this.kefuData.phone;
        // }else{
            this.kefu_name = info.nickName;
            this.kefu_phone = info.phone;
        // }
        
        // this.websocketInit();
            // 是否正在聊天
            let isOnChat = false;
            this.onChat.forEach(item => {
                if(item.id == info.id){
                    isOnChat = true;
                }
            });

            if(!isOnChat){
                this.onChat.push(info);
            }

            // 获取聊天记录列表
            this.get_chat_msg(info);
            //定时请求聊天记录
            this.timeObj = setInterval(()=>{
                this.get_chat_msg();
            },10000);
        },


        // 关闭窗口
        closeWin:function(){
            this.minimizes = true;
            // this.onChatIndex = 0;
            // if(this.onChat.length<=1){
            //     return this.onChat = [];
            // }
            // this.onChat.forEach((item,key)=>{
            //     if(item.id == info.id){
            //         this.onChat.splice(key,1);
            //     }
            // });
        },
        // 获取聊天记录列表
        get_chat_msg:function(){
            let receive
            if(this.kefuData){
                receive = 100000000 + this.kefuData[0].id ;
            }else{
                receive = 100000000 + this.chat_friend.id ;
            }
            this.$get(this.$api.chatGetChatMsg,{userId:this.user_id,kefuId:receive,pageNum:this.pageNum,pageSize:this.pageSize,platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.onChatMsg = res.data.list;
                    this.Num = res.data.totalPage;
                    // this.clearNoRead(this.user_info.id,item.id); // 将该正在聊天未读标记已读
                    this.scrollDown();
                    this.$forceUpdate();
                    
                }else{
                    this.$message.error('聊天信息加载失败');
                }
            });
        },

        //查看聊天记录
        viewsChatRecord:function(){
            this.$router.push({path:'/chats/chatRecord'});
        },

        //上传图片
        handleAvatarSuccess(res) {
            let receive
            if(this.kefuData){
                receive = 100000000 + this.kefuData[0].id ;
            }else{
                receive = 100000000 + this.chat_friend.id ;
            }
            console.log(this.chat_friend.id);
            this.$post(this.$api.sendChat,{user:this.user_id,receive:receive,type:'104',message:res.data,platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.message);
                    this.sendMsg.message = '';
                }else{
                    this.$message.error(res.message);
                }
            });
        },

        //上传附件
        handleAvatarSuccessFile(res) {
            let receive
            if(this.kefuData){
                receive = 100000000 + this.kefuData[0].id ;
            }else{
                receive = 100000000 + this.chat_friend.id ;
            }
            this.$post(this.$api.sendChat,{user:this.user_id,receive:receive,type:'106',message:res.data,platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    this.$message.success(res.message);
                    this.sendMsg.message = '';
                }else{
                    this.$message.error(res.message);
                }
            });
        },


        //滚动加载聊天记录
        loadMore(){	    	
          setTimeout(() => {
            if(this.Num > this.pageNum){
              this.pageNum = this.pageNum + 1;
              this.get_chat_msg();
            }else{
              this.loading = false;
              this.loadend = true;
            }
              }, 500);	    	
        },

      //右键菜单
      handleRightMenu:function(info){
      this.chatId = info.id;
      this.chatUserId = info.userId;
      // if(this.userInfo.id == this.chatUserId){
      //   this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      //   this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      // }
        this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
        this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      // this.$message.error('暂未开通!');

      },

      //关闭按钮
      closeMenu() {
        this.menuVisible = false
      },

      //撤回消息
      handleRecant(info){
        if(this.userInfo.id == this.chatUserId){
            this.$post(this.$api.RevokeChat,{userId:this.user_id,data:[info.id]}).then(response => {
            if(response.code == 200){
              this.menuVisible = false;
              this.get_chat_msg();
              this.$message.success(response.message);
            }else{
              this.$message.error(response.message);
            }
          })
        }else{
          this.$message.error('只能撤回本人发送的消息!');
        }

      },

      //删除消息
      handleDelete(info){
        this.$post(this.$api.DeleteChat,{userId:this.user_id,data:[info.id]}).then(response => {
            if(response.code == 200){
              this.menuVisible = false;
              this.get_chat_msg();
              this.$message.success(response.message);
            }else{
              this.$message.error(response.message);
            }
          })
      },

     //查看大图
      handleViews(info){
        if(info != null){
          window.open(info,"_blank");
        }
        //   let url = info.message;
        //   window.location.replace(url);
      },
 



      handleViewFile(info){
        if(info != null){
          window.open(info,"_blank");
        }
      },

    },
    created() {
        this.get_user_info();
        this.filepath();
        // this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {},
    destroyed () {
        // 销毁监听
        // this.socket.onclose = this.close
    }
};
</script>
<style lang="scss" scoped>
.chat_image{
    max-width: 200px;
    max-height: 200px;
}
.emoji_block{
    height: 170px;
    position: absolute;
    background: #fff;
    top: 150px;
    .el-scrollbar{
        height: 170px;
    }
}
.emoji_class{
    margin-right: 10px;
    padding-top: 10px;
    float: left;
}
.chat_interface{
    border-radius: 3px;
    .chat_interface_left{
        float: left;
        width: 200px;
        background: #409EFF;
        height: 100%;
        border-radius: 3px 0 0 3px;
        dl{
            padding: 10px 0;
            clear: both;
            cursor: pointer;
            dt{
                width: 40px;
                height: 40px;
                img{
                    width: 100%;
                    height: 100%;
                }
                float: left;
                margin-right: 15px;
                margin-left: 15px;
            }
            dd{
                float: left;
                overflow: hidden;
                color:#999;
                line-height: 40px;
                height: 30px;
                width: 100px;
            }
            dd.close{
                float: right;
                width: 20px;
                height: 30px;
                margin-right: 5px;
                cursor:pointer;
                display: none;
            }
        }
        dl.active{
            background: rgb(83, 168, 255);
            dd{
                color:#fff;
            }
        }
        dl.active2{
            background: #333;
            opacity: 0.7;
            dd{
                color:#fff;
            }
        }
        dl:nth-child(1).active{
            border-radius: 3px 0 0 0;
        }
        dl:hover dd.close{
            display: block;
            color:#fff;
        }
        dl:after{
            content:'';
            clear:both;
            display: block;
        }
    }
    .chat_interface_right{
        float: right;
        width: 600px;;
        .chat_interface_right_top{
            background: #efefef;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            border-radius: 0 3px 0 0;
            i{
                float:right;
                margin-right: 15px;
            }
        }
        .chat_interface_right_content{
            height: 280px;
            padding-bottom: 15px;
            box-sizing: border-box;
            .el-scrollbar{
                height: 265px;
            }
            .chat_interface_msg_item{
                padding: 15px 0 0 15px;
                .chat_interface_msg_avatar{
                    background-color: #efefef;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    float: left;
                    margin-right: 15px;
                    img{
                        border-radius: 50%;
                        width: 100%;
                        height: 100%;
                    }
                }
                .chat_interface_msg_time{
                    font-size: 12px;
                    margin-top: 10px;
                    color:#666;
                    line-height: 20px;
                    span{
                        float: left;
                        font-size: 14px;
                        color:#333;
                        margin-right: 15px;
                        font-weight: bold;
                    }
                }
                .chat_interface_msg_time:after{
                    content:'';
                    display: block;
                    clear: both;
                }
                .chat_interface_msg{
                    font-size: 12px;
                    line-height: 20px;
                    padding: 5px 8px;
                    background: #efefef;
                    border-radius: 5px;
                    margin-top: 10px;
                    word-wrap:break-word;
                    // display:inline-block;
                    // min-width: 140px;
                    max-width: 400px;
                    height: 100%;
                    margin-left: 52px;
                    cursor: pointer;
                }
            }
            .me{
                .chat_interface_msg_avatar{
                    float: right;
                }
                .chat_interface_msg_time{
                    float: right;
                    span{
                        float: right;
                        margin-left: 20px;
                    }
                }
                .chat_interface_msg{
                    background: #67C23A;
                    color:#fff;
                    float: right;
                    clear:both;
                    margin-right: 65px;
                    // text-align: right;
                }
            }
            .me:after{
                content:'';
                display: block;
                clear: both;
            }
        }
        .chat_interface_right_send{
            .chat_interface_right_send_tool{
                margin-right: 10px;
                .tool_item{
                    line-height: 18px;
                    margin-top: 5px;
                    margin-bottom: 5px;
                    padding:4px 6px;
                    float: left;
                    border-radius: 3px;
                    i{
                        font-size: 18px;
                    }
                }
                .tool_item:hover{
                    background: #efefef;
                }
                .other_tool_item{
                    float:left;
                    font-size: 14px;
                    // i{
                    //     margin-right: 10px;
                    // }
                }
            }
            .chat_interface_right_send_tool:after{
                content:'';
                clear: both;
                display: block;
            }
            .chat_interface_right_send_text{
                height: 50px;
                textarea{
                    font-family:'微软雅黑',  Arial, sans-serif;
                    width: 100%;
                    height: 50px;
                    padding: 5px;
                    color:#666;
                    outline: none;
                    border:none;
                    box-sizing: border-box;
                }
            }
            .chat_interface_right_send_text_btn{
                button{
                    // background: #fff;
                    // border:1px solid #efefef;
                    border-radius: 3px;
                    float:right;
                    margin-right: 15px;
                    // line-height: 25px;
                    margin-top: 5px;
                    outline: none;
                    cursor:pointer;
                }
                button:nth-child(1){
                    border: none;
                    // background: #333;
                    color:#fff;
                }
                
            }
            border-top: 1px solid #efefef;
        }
    }
    width: 800px;
    height: 460px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 1005;
    position: fixed;
    left: 50%;
    top: 50%;
    background: #fff;
    transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
}
.chat_friend_interface_content{
    dl{
        padding: 15px 0 10px 0; 
        dt{
            width: 40px;
            height: 40px;
            display: blcok;
            float: left;
            margin-left: 15px;
            margin-right: 15px;
            img{
                border-radius: 50%;
                width: 100%;
                height: 100%;
            }
        }
        dd{
            float: left;
            width: 165px;
            line-height: 20px;
            height: 20px;
            font-size: 14px;
            display: block;
            position: relative;
            span{
                border-radius: 50%;
                background: #409EFF;
                color:#fff;
                width: 8px;
                height: 8px;
                position: absolute;
                right: 0px;
                z-index: 1001;
                top: -5px;
            }
        }
        dd.friend_new{
            color:#999;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            height: 16px;
            display: block;
        }
    }
    dl:hover{
        // background: #fcfcfc;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    dl:after{
        content:'';
        clear: both;
        display: block;
    }
}
.chat_friend_interface_tab{
    ul{
        border-bottom: 1px solid #efefef;
        li{
            float: left;
            width: 50%;
            text-align: center;
            line-height: 40px;
            color:#999;
            position: relative;
            .border_b{
                border-bottom: 1px solid #333;
                display: none;
                width: 80%;
                margin:0 auto;
                margin-bottom: -1px;
            }
        }
        li:hover{
            color: #333;
        }
        li.border_b_show{
            color:#333;
        }
        li.border_b_show .border_b{
            display: block;
        }
        
    }
    ul:after{
        content:'';
        clear: both;
        display: block;
    }
}
.small_chat{
    z-index: 1000;
    color:#409EFF;
    position: fixed;
    right: 40px;
    bottom: 90px;
    i{
        font-size: 50px;
    }
}
.chat_friend_interface{
    z-index: 1000;
    width: 260px;
    height: 520px;
    position: fixed;
    right: 40px;
    bottom: 0;
    background: #fff;
    .chat_friend_interface_head{
        height: 80px;
        background: #333;
        color:#fff;
        .head_top_info{
            span{
                line-height: 50px;
                margin-left: 15px;
                float: left;
                height: 50;
                overflow: hidden;
                
            }
            font{
                float: left;    
                margin-top: 18px;  
                margin-left: 8px;  
            }
            i{
                float: right;
                line-height: 40px;
                margin-right: 10px;
            }
        }
        .head_top_info:after{
            content:'';
            clear: both;
            display: block;
        }
    }
    .chat_friend_interface_head_desc{
        font-size: 12px;
        color:#f4f4f4;
        margin-left: 15px;
    }
}
.red{
    width: 12px;
    height: 12px;
    display: block;
    border-radius: 50%;
    background: #409EFF;
}
.green{
    width: 12px;
    height: 12px;
    display: block;
    border-radius: 50%;
    background: #67C23A;
}
.chat_shodow{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.chat_handle{
    cursor:pointer;
}

@font-face {
  font-family: 'iconfont';  /* project id 1617825 */
  src: url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.eot');
  src: url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.woff') format('woff'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.svg#iconfont') format('svg');
}
.center{
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
  line-height: 20px;
}
.el-image__error, .el-image__inner, .el-image__placeholder {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
// .image-slot{
//     background: none !important;
// }
.el-icon-picture-outline{
  margin-top: 12px;
  margin-left: 12px;
}

</style>
